module.exports = __webpack_public_path__ + "static/images/popup/newsletter/img-1.jpg";